import Axios from "axios";
import {
  SET_BALANCE_SHEET_REPORT,
  UNSET_BALANCE_SHEET_REPORT,
} from "@/store/mutation-types";
import {
  getBalanceSheetReport,
} from "@/store/api";

const state = {
  balanceSheetReport: [],
};

const getters = {
  getBalanceSheetReport(state) {
    return state.balanceSheetReport;
  },
};

const mutations = {
  [SET_BALANCE_SHEET_REPORT](state, data) {
    state.balanceSheetReport = data;
  },
  [UNSET_BALANCE_SHEET_REPORT](state) {
    state.balanceSheetReport = [];
  },
};

const actions = {
  getBalanceSheet({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getBalanceSheetReport}`, { params: data })
        .then((response) => {
          commit(SET_BALANCE_SHEET_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_BALANCE_SHEET_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

